import '@babel/polyfill';
require('intersection-observer');

import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import dotenv from 'dotenv';

import estilosT from "./assets/demo5/sass/style.scss";

import { Validator } from 'vee-validate';
import VueMaterial from 'vue-material';

import es from 'vee-validate/dist/locale/es';
import moment from 'moment';
import BootstrapVue from 'bootstrap-vue';
import VueIziToast  from "vue-izitoast";
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import './servicios/configuracion';






moment.locale("es");
Vue.use(VueMaterial);
Vue.use(VueIziToast);
Vue.use(estilosT);
Vue.use(BootstrapVue);
Vue.use(VueTheMask);









Validator.localize('es', es);
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

dotenv.config();


Vue.use(VueSweetalert2,{
  confirmButtonColor: '#05141f',
});



new Vue({
  router:router,
  render: h => h(App),
}).$mount('#app');
